import React, { forwardRef } from 'react';

import { TextButton } from '../TextButton/TextButton';
import type { TextButtonProps } from '../TextButton/types';
import { ICON_BUTTON__BUTTON_CLASS, ICON_BUTTON__ICON_CLASS } from './classNames';
import * as styles from './styles';

type TextIconVariant = 'leading' | 'trailing';

export interface TextIconProps extends TextButtonProps {
  icon: string;
  iconHeight: number;
  iconWidth: number;
  variant?: TextIconVariant;
}

export const TextIcon = forwardRef<HTMLButtonElement | null, TextIconProps>(
  (
    { children, icon, iconHeight, iconWidth, variant = 'trailing', ...buttonProps }: TextIconProps,
    forwardedRef,
  ) => (
    <TextButton
      className={ICON_BUTTON__BUTTON_CLASS}
      css={styles.iconButton}
      data-variant={variant}
      ref={forwardedRef}
      {...buttonProps}
    >
      {children}
      <img
        alt=""
        className={ICON_BUTTON__ICON_CLASS}
        height={iconHeight}
        src={icon}
        width={iconWidth}
      />
    </TextButton>
  ),
);
